import { sortBy } from 'lodash';
import React from 'react';
import BoxScore from '~/src/components/BoxScore';
import { Urls } from '~/src/lib/enums/urls';
import { OteGame } from '~/src/models/OteGame';
import { OteGameOtePlayerOteTeam } from '~/src/models/OteGameOtePlayerOteTeam';
import { OtePlayer } from '~/src/models/OtePlayer';
import { OteSeason } from '~/src/models/OteSeason';
import FormattedTimestamp from '~/src/overtime-lib/src/www/components/FormattedTimestamp';
import useFetch from '~/src/overtime-lib/src/www/hooks/useFetch';
import './Season.scss';

const Season = ({ season, player }: { season: OteSeason; player: OtePlayer }) => {
	const fetchResult = useFetch<OteGame[]>({
		url: `${Urls.ApiRestOteSeasonsUrl}/${season.id}/ote_games?ote_player_id=${player.id}`,
		key: 'ote_games',
	});
	const seasonPlayer = player.ote_seasons_ote_players.find((s) => s.ote_season_id === season.id);

	const games = sortBy(
		fetchResult.result.read().filter((g) => g.ote_games_ote_players_ote_teams[0]?.minutes > 0),
		'starts_at',
	);

	return (
		<div className="PlayerSeason">
			<BoxScore
				title="Game"
				rows={games.map((g) => ({ ...g.ote_games_ote_players_ote_teams[0], ote_game: g }))}
				averageRow={seasonPlayer}
				per40Row={seasonPlayer}
				rowHeader={(r: OteGameOtePlayerOteTeam) =>
					season.should_show_for_teams ? (
						<a href={`/games/${r.ote_game_id}`} className="Game">
							<div title={r.ote_game.competition_name}>
								{r.ote_game.ote_games_ote_teams.find((t) => !t.is_home_team).ote_team.name}
								{' @\n'}
								{r.ote_game.ote_games_ote_teams.find((t) => t.is_home_team).ote_team.name}
							</div>
							<div className="Date">
								<FormattedTimestamp timestamp={r.ote_game.starts_at} />
							</div>
						</a>
					) : (
						<div className="Game">
							<div title={r.ote_game.competition_name}>
								{r.ote_game.ote_games_ote_teams.find((t) => !t.is_home_team).ote_team.name}
								{' @\n'}
								{r.ote_game.ote_games_ote_teams.find((t) => t.is_home_team).ote_team.name}
							</div>
							<div className="Date">
								<FormattedTimestamp timestamp={r.ote_game.starts_at} />
							</div>
						</div>
					)
				}
			></BoxScore>
		</div>
	);
};

export default Season;
